import Typography from "components/typography";
import { useClickOutside } from "hooks/UseClickOutside";
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  isopen: boolean;
  closeMenu: (value: boolean) => void;
  trackId: string;
  type: string;
  takedown: () => void;
}
const TrackMenu = ({ isopen, closeMenu, trackId, type, takedown }: IProps) => {
  const ref = useRef(null);
  const navigate = useNavigate();

  useClickOutside(ref, () => {
    closeMenu(true);
  });
  return (
    <Container isopen={isopen ? "true" : "false"} ref={ref}>
      <MenuItem
        onClick={() => {
          navigate(`/overview/discography/track/${trackId}?type=${type}`);
        }}
      >
        <Typography size="s">View Track</Typography>
      </MenuItem>
      <MenuItem>
        <Typography size="s"> RAted Fans Link</Typography>
      </MenuItem>
      <MenuItem onClick={takedown}>
        <Typography size="s">Takedown Track</Typography>
      </MenuItem>
    </Container>
  );
};

export default TrackMenu;

const Container = styled.div<{ isopen: string }>`
  min-width: 15.8rem;
  background-color: ${Colors.grey1000};
  position: absolute;
  padding: 0.6rem;
  right: 0;
  bottom: 90%;
  border-radius: 0.8rem;
  display: ${(props) => (props.isopen === "true" ? "block" : "none")};
  z-index: 5;

  @media only screen and (max-width: 769px) {
    bottom: 0%;
  }
`;

const MenuItem = styled.div`
  width: 100%;
  margin-bottom: 0.4rem;
  padding: 0.7rem 1.2rem;
  border-radius: 0.8rem;
  cursor: pointer;
  &:hover {
    background-color: ${Colors.grey700};
  }
`;
